import { getMetaFile } from '@app/crud/meta.crud';

export const APP_VERSION_STORAGE_KEY = 'APP_VERSION';
export const RELOADED_VERSION_STORAGE_KEY = 'APP_VERSION_RELOADED';

export function getStoredAppVersion(): string | null {
    return localStorage.getItem(APP_VERSION_STORAGE_KEY);
}

export function storeAppVersion(version: string) {
    localStorage.setItem(APP_VERSION_STORAGE_KEY, version);
}

export function hasAlreadyReloadedFor(version: string) {
    return sessionStorage.getItem(RELOADED_VERSION_STORAGE_KEY) === version;
}

export async function fetchDeployedVersion(): Promise<string | null> {
    const response = await getMetaFile();

    return response?.data?.version || null;
}

export function refreshDocumentCache(): Promise<boolean> {
    return fetch(globalThis.location.href, { cache: 'reload' })
        .then((response) => response.ok)
        .catch(() => false);
}

export function commitVersionAndReload(version: string) {
    sessionStorage.setItem(RELOADED_VERSION_STORAGE_KEY, version);
    storeAppVersion(version);
    globalThis.location.reload();
}
